export var PaymentType;
(function (PaymentType) {
    PaymentType["WEB_ATM"] = "web_atm";
    PaymentType["CREDIT_CARD"] = "credit_card";
})(PaymentType || (PaymentType = {}));
